import React, { useEffect, useState } from "react";
// import "./AttendanceReports.css"; // optional CSS file for table styling
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
const API_BASE_URL = "https://docpay.vdcapp.in/backend/";
const token = sessionStorage.getItem("token");

export default function AttendanceReports() {
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
const token = localStorage.getItem('jwt_token');
  // ✅ Fetch attendance history from backend
  const fetchAttendanceRecords = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}api/doctor_attendance_history`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.status === 200) {
        setAttendanceRecords(data.data || []);
      } else {
        setAttendanceRecords([]);
      }
    } catch (error) {
      console.error("❌ Error fetching attendance history:", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Fetch data on mount
  useEffect(() => {
    fetchAttendanceRecords();
  }, []);

  // ✅ Pagination logic
  const indexOfLastRecord = currentPage * pageSize;
  const indexOfFirstRecord = indexOfLastRecord - pageSize;
  const currentRecords = attendanceRecords.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(attendanceRecords.length / pageSize);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="wrapper">
               <Sidebar />
               <main className="main-content content-page">
                    <div className="position-relative">
                         <Navbar />
                    </div>
    <div className="container mt-4">
      <h2 className="text-center mb-4">Doctor Attendance History</h2>

      {loading ? (
        <p className="text-center">Loading attendance history...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>ID</th>
                <th>Doctor Code</th>
                <th>Attendance Date</th>
                
                <th>New In Time</th>
                <th>New Out Time</th>
                <th>Updated By</th>
                <th>Updated On</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.length > 0 ? (
                currentRecords.map((record) => (
                  <tr key={record.id}>
                    <td>{record.id}</td>
                    <td>{record.doct_code}</td>
                    <td>{record.attendance_date}</td>
                    
                    <td>{record.new_in_time}</td>
                    <td>{record.new_out_time}</td>
                    <td>{record.updated_by}</td>
                    <td>{record.updated_on}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center">
                    No attendance history found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* ✅ Pagination Controls */}
      <div className="d-flex justify-content-center mt-3">
        <nav>
          <ul className="pagination">
            {Array.from({ length: totalPages }, (_, index) => (
              <li
                key={index + 1}
                className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => handlePageChange(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
    </main>
    </div>
  );
}
